import React, { useState, useRef, useEffect } from "react";
import { ButtonGroup, Form, InputGroup, ListGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Button, Dropdown } from "react-bootstrap";
import Search from "../assets/images/search-icon.svg";
import SearchIcon from "../assets/images/search-white-icon.svg.svg"
import Location from "../assets/images/location-icon-3.svg"
import TooltipIcon from '../assets/images/tooltip.svg'
import TooltipIconOne from '../assets/images/tooltip-1.svg'
import MoreFilter from '../assets/images/more-filter.svg'
import FilterIcon from '../assets/images/filter.svg'
import CloseIcon from '../assets/images/modal-close.svg'
import useSuburbs from "../hooks/useSuburbs";
import { useNavigate } from "react-router-dom";


const FilterBar = () => {
  const navigate = useNavigate();


  const [sizeSqft, setSizeSqft] = useState("No Min");
  const [maxSizeSqft, setMaxSizeSqft] = useState("No Max");
  const [minYearBuilt, setMinYearBuilt] = useState("No Min");
  const [maxYearBuilt, setMaxYearBuilt] = useState("No Max");

  // Search box
  const inputGroupRef = useRef(null);
  const [inputHeight, setInputHeight] = useState(0);
  const [query, setQuery] = useState("");
  const [filtered, setFiltered] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [recentSearches, setRecentSearches] = useState(() => {
    const saved = localStorage.getItem("recentSearches");
    return saved ? JSON.parse(saved) : [];
  });

  // Price
  const [showPriceDropdown, setShowPriceDropdown] = useState(false);
  const [priceTab, setPriceTab] = useState("list");
  const [minPrice, setMinPrice] = useState("No Min");
  const [maxPrice, setMaxPrice] = useState("No Max");
  // Beds & Baths 
  const [showBedsDropdown, setShowBedsDropdown] = useState(false);
  const [selectedBeds, setSelectedBeds] = useState("Any");
  const [useExactMatch, setUseExactMatch] = useState(false);
  const [selectedBaths, setSelectedBaths] = useState("Any");
  const [downPayment, setDownPayment] = useState('');

  // Home type
  const [showHomeTypeDropdown, setShowHomeTypeDropdown] = useState(false);
  const [selectedHomeTypes, setSelectedHomeTypes] = useState([]);
  // More Filter
  const [showMoreFilterDropdown, setShowMoreFilterDropdown] = useState(false);
  const applyMoreFilters = () => {
    setShowMoreFilterDropdown(false);
  };
  const { suburbs } = useSuburbs();

  useEffect(() => {
    if (inputGroupRef.current) {
      const height = inputGroupRef.current.offsetHeight;
      setInputHeight(height);
    }
  }, []);
  useEffect(() => {
    const handleResize = () => {
      if (inputGroupRef.current) {
        setInputHeight(inputGroupRef.current.offsetHeight);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    setShowDropdown(true);

    if (value.length > 0) {
      const results = suburbs.filter((item) =>
        item.toLowerCase().includes(value.toLowerCase())
      );
      setFiltered(results);
    } else {
      setFiltered(suburbs);
    }
  };

  const handleSelect = (item) => {
    setQuery(item);
    setFiltered([]);
    setShowDropdown(false);
    const updated = [item, ...recentSearches.filter(s => s !== item)].slice(0, 5);
    setRecentSearches(updated);
    localStorage.setItem("recentSearches", JSON.stringify(updated));
  };

  const handleFocus = () => {
    setShowDropdown(true);
    if (query.length === 0) {
      setFiltered(recentSearches.slice(0, 5));
    }
  };

  const handleBlur = () => {
    setTimeout(() => setShowDropdown(false), 200);
  };

  // For Sale
  const [listingType, setListingType] = useState("For Sale");
  const [showTypeDropdown, setShowTypeDropdown] = useState(false);




  // Price
  const priceOptions = [
    "No Min",
    "50000",
    "100000",
    "200000",
    "500000",
    "1000000",
    "2000000",
    "No Max",
  ];

  const applyPriceFilter = () => {
    setShowPriceDropdown(false);
  };

  // Beds & Baths Dropdown
  const applyBedsFilter = () => {
    setShowBedsDropdown(false);
  };

  // Home type 
  const homeTypes = ["Single Family", "Condo", "Townhouse", "Multi-Family"];

  const applyHomeTypeFilter = () => {
    setShowHomeTypeDropdown(false);
  };

  const toggleHomeType = (type) => {
    setSelectedHomeTypes((prev) =>
      prev.includes(type) ? prev.filter((t) => t !== type) : [...prev, type]
    );
  };

  const selectAllHomeTypes = () => {
    setSelectedHomeTypes(homeTypes);
  };

  const deselectAllHomeTypes = () => {
    setSelectedHomeTypes([]);
  };

  // Listing Type
  const listingTypes = [
    { key: 'new_construction', label: 'New Construction' },
    { key: 'foreclosure', label: 'Foreclosures' },
    { key: 'coming_soon', label: 'Coming Soon' },
  ];

  const [listingTypeFilters, setListingTypeFilters] = useState({});
  const toggleListingType = (key) =>
    setListingTypeFilters(prev => ({ ...prev, [key]: !prev[key] }));


  const [showMobileFilter, setShowMobileFilter] = useState(false);

  const normalizeFilters = (filters) => {
    const normalizeValue = (value) => {
      if (
        value === "Any" ||
        value === "No Min" ||
        value === "No Max" ||
        value === "" ||
        value === undefined ||
        value === null
      ) {
        return null;
      }

      // 🔁 UI → API mapping
      const map = {
        "For Sale": "sale",
        "For Rent": "rent",
        "Sold": "recent_sale",
      };

      return map[value] ?? value;
    };



    return {
      suburb: normalizeValue(filters.suburb),
      bedrooms: normalizeValue(filters.bedrooms),
      bathrooms: normalizeValue(filters.bathrooms),
      listing_types: normalizeValue(filters.listing_types),
      min_price: normalizeValue(filters.min_price),
      max_price: normalizeValue(filters.max_price),
      size_sqft: normalizeValue(filters.size_sqft),
      max_size_sqft: normalizeValue(filters.max_size_sqft),
      min_year_built: normalizeValue(filters.min_year_built),
      max_year_built: normalizeValue(filters.max_year_built),
      down_payment_min: normalizeValue(filters.down_payment),
      sale_types: normalizeValue(filters.sale_types),
      categories:
        Array.isArray(filters.categories) && filters.categories.length
          ? filters.categories
          : null,
    };
  };


  //quick search
  const handleQuickSearch = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    const input = form.querySelector('input[type="search"]');
    const value = input?.value?.trim();

    if (!value) return;

    const suburbName = value.split(",")[0].trim();

    const url = `/search?suburb=${encodeURIComponent(suburbName)}`;

    if (window.location.pathname === "/search") {
      window.location.href = url;
    } else {
      navigate(url);
    }

  };


  //search with filters
  const handleSubmit = async (e) => {
    if (!query) return;

    if (!listingTypeFilters || typeof listingTypeFilters !== "object") return null;

    // get keys where value is truthy
    const selectedSaleTypes = Object.keys(listingTypeFilters).filter(key => listingTypeFilters[key]);

    // Extract only the suburb name (before the first comma)
    const suburbName = query.split(",")[0].trim();
    const filters = {
      listing_types: listingType,
      min_price: minPrice,
      max_price: maxPrice,
      down_payment: downPayment,
      suburb: suburbName,
      bedrooms: selectedBeds,
      bathrooms: selectedBaths,
      categories: selectedHomeTypes,
      size_sqft: sizeSqft,
      max_size_sqft: maxSizeSqft,
      min_year_built: minYearBuilt,
      max_year_built: maxYearBuilt,
      categories: selectedHomeTypes,
      sale_types: selectedSaleTypes,

    }
    console.log("Search filters:", filters);

    try {
      sessionStorage.setItem("searchFilters", JSON.stringify(normalizeFilters(filters)));
      console.log(listingTypeFilters)
      const url = `/search`;

      if (window.location.pathname === "/search") {
        window.location.href = url;
      } else {
        navigate(url);
      }
    } catch (err) {
      console.error("Search error:", err);
    }
  };


  return (
    <>
      <Button
        className="custom-bttn primary-line ani-1 left d-flex d-xl-none"
        onClick={() => setShowMobileFilter(!showMobileFilter)}
      >
        <img src={FilterIcon} alt="" /> Filters
      </Button>
      <div className={`filter-box ${showMobileFilter ? '' : 'd-none'} d-xl-flex`}>
        <div className={`filter-header ${showMobileFilter ? '' : 'd-none'}`}>

          <Button
            className="filter-close"
            onClick={() => setShowMobileFilter(!showMobileFilter)}
          >
            <img src={CloseIcon} alt="" />
          </Button>
        </div>
        <Form onSubmit={handleQuickSearch}>

          <InputGroup ref={inputGroupRef}>
            <Form.Control
              type="search"
              placeholder="Search"
              value={query}
              onChange={handleChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
            <Button type="submit">
              <img src={Search} alt="" />
            </Button>

          </InputGroup>
          {showDropdown && filtered.length > 0 && (
            <ListGroup style={{ top: inputHeight + 4, }}>
              {query.length === 0 && recentSearches.length > 0 && (
                <ListGroup.Item className="recent-search">
                  <span>Recent Search</span>
                </ListGroup.Item>
              )}
              {filtered.map((item, index) => (
                <ListGroup.Item
                  key={index}
                  action
                  onClick={() => handleSelect(item)}
                >
                  <img src={Location} alt="" /> {item}
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </Form>
        <Dropdown className="for-sale"
          show={showTypeDropdown}
          onToggle={(open) => setShowTypeDropdown(open)}
          align="end"
        >
          <Dropdown.Toggle
            id="property-type-dropdown"
          >
            {listingType}
          </Dropdown.Toggle>

          <Dropdown.Menu as="div" className="for-sale">
            <div>
              <Form.Check
                type="radio"
                id="pt-sale"
                name="propertyType"
                label="For Sale"
                className='custom-radio'
                checked={listingType === "For Sale"}
                onChange={() => setListingType("For Sale")}
              />
              <Form.Check
                type="radio"
                id="pt-rent"
                name="propertyType"
                label="For Rent"
                className='custom-radio'
                checked={listingType === "For Rent"}
                onChange={() => setListingType("For Rent")}
              />
              <Form.Check
                type="radio"
                id="pt-sold"
                name="propertyType"
                label="Sold"
                className='custom-radio'
                checked={listingType === "Sold"}
                onChange={() => setListingType("Sold")}
              />
            </div>

            <Button
              className="custom-bttn w-100"
              onClick={() => {
                setShowTypeDropdown(false);
              }}
            >
              Apply
            </Button>
          </Dropdown.Menu>
        </Dropdown>
        <Dropdown
          show={showPriceDropdown}
          onToggle={(open) => setShowPriceDropdown(open)}
          align="end"
        >
          <Dropdown.Toggle id="price-range-dropdown">
            Price Range
          </Dropdown.Toggle>

          <Dropdown.Menu as="div" className="price-dropdown">
            <h3 className="dropdown-title">Price Range</h3>
            <div className="price-box">
              <div className="price-tabs d-flex">
                <button
                  type="button"
                  className={`tab ${priceTab === "list" ? "active" : ""}`}
                  onClick={() => setPriceTab("list")}
                >
                  List Price
                </button>
                <button
                  type="button"
                  className={`tab ${priceTab === "monthly" ? "active" : ""}`}
                  onClick={() => setPriceTab("monthly")}
                >
                  Monthly Payment
                </button>
              </div>


              <Form className="w-100">
                <div className="d-flex gap-3 mb-3 w-100">
                  <div className="d-flex flex-column flex-grow-1">
                    <Form.Label>Minimum price</Form.Label>
                    <Form.Select value={minPrice} onChange={(e) => setMinPrice(e.target.value)} aria-label="Minimum price">
                      {priceOptions.map((opt) => (
                        <option key={opt} value={opt}>{opt}</option>
                      ))}
                    </Form.Select>
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <Form.Label>Maximum price</Form.Label>
                    <Form.Select value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)} aria-label="Maximum price">
                      {priceOptions.map((opt) => (
                        <option key={opt} value={opt}>{opt}</option>
                      ))}
                    </Form.Select>
                  </div>
                </div>
                {priceTab === "monthly" && (
                  <>
                    <p>
                      Includes estimated principal and interest, mortgage insurance, property taxes, home insurance and HOA fees.
                    </p>
                    <div className="d-flex tooltip-box">
                      <Form.Label className="mb-0">Down payment</Form.Label>
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="credit-score-tooltip">
                            How much you're required to put down on a house is determined by the type of loan you get, but it generally ranges from 3% to 20% of the purchase price of the home.
                          </Tooltip>
                        }
                      >
                        <img src={TooltipIcon} alt="" />
                      </OverlayTrigger>
                    </div>
                    <Form.Select aria-label="Down payment" name="down_payment" value={downPayment} onChange={(e) => setDownPayment(e.target.value)}>
                      <option>No Down Payment</option>
                      <option value={5}>5%</option>
                      <option value={10}>10%</option>
                      <option value={20}>20%</option>
                    </Form.Select>
                  </>
                )}

                <Button className="custom-bttn w-100" onClick={applyPriceFilter}>
                  Apply
                </Button>
              </Form>
            </div>
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown
          show={showBedsDropdown}
          onToggle={(open) => setShowBedsDropdown(open)}
          align="end"
          className="ms-2"
        >
          <Dropdown.Toggle id="beds-baths-dropdown">
            Beds & Baths
          </Dropdown.Toggle>

          <Dropdown.Menu as="div" className="beds-baths-dropdown">
            <h5 className="dropdown-title">Beds & Baths</h5>
            <div className="beds-baths-box">
              <div className="bedrooms-section">
                <h6>Bedrooms</h6>
                <div className="bed-options">
                  <button
                    type="button"
                    className={`bed-btn ${selectedBeds === "Any" ? "active" : ""}`}
                    onClick={() => setSelectedBeds("Any")}
                  >
                    Any
                  </button>
                  {[1, 2, 3, 4, 5].map((num) => (
                    <button
                      key={num}
                      type="button"
                      className={`bed-btn ${selectedBeds === num ? "active" : ""}`}
                      onClick={() => setSelectedBeds(num)}
                    >
                      {num}
                    </button>
                  ))}
                </div>
                <Form.Check
                  type="checkbox"
                  id="exact-match"
                  label="Use Exact match"
                  checked={useExactMatch}
                  onChange={(e) => setUseExactMatch(e.target.checked)}
                  className="custom-checkbox primary mb-3"
                />
              </div>
              <div className="bathrooms-section">
                <h6>Bathrooms</h6>
                <div className="bath-options">
                  <button
                    type="button"
                    className={`bath-btn ${selectedBaths === "Any" ? "active" : ""}`}
                    onClick={() => setSelectedBaths("Any")}
                  >
                    Any
                  </button>
                  {["1+", "1.5+", "2+", "3+", "4+"].map((num) => (
                    <button
                      key={num}
                      type="button"
                      className={`bath-btn ${selectedBaths === num ? "active" : ""}`}
                      onClick={() => setSelectedBaths(num)}
                    >
                      {num}
                    </button>
                  ))}
                </div>
              </div>

              <Button className="custom-bttn w-100" onClick={applyBedsFilter}>
                Apply
              </Button>
            </div>
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown
          show={showHomeTypeDropdown}
          onToggle={(open) => setShowHomeTypeDropdown(open)}
          align="end"
        >
          <Dropdown.Toggle id="home-type-dropdown">
            Home Type
            {/* {selectedHomeTypes.length > 0 ? selectedHomeTypes.join(", ") : "Any"} */}
          </Dropdown.Toggle>

          <Dropdown.Menu as="div" className="home-type-dropdown">
            <h5 className="dropdown-title">Home Type</h5>
            <div className="home-type-options">
              <Form.Check
                type="checkbox"
                id="select-all"
                label="Select All"
                className="custom-checkbox primary select-all"
                onChange={(e) => {
                  if (e.target.checked) {
                    selectAllHomeTypes();
                  } else {
                    deselectAllHomeTypes();
                  }
                }}
                checked={selectedHomeTypes.length === homeTypes.length}
              />
              {homeTypes.map((type) => (
                <Form.Check
                  key={type}
                  type="checkbox"
                  id={`home-type-${type}`}
                  label={type}

                  className="custom-checkbox primary"
                  onChange={() => {
                    toggleHomeType(type);
                  }}
                  checked={selectedHomeTypes.includes(type)}
                />
              ))}
              <Button className="custom-bttn w-100 mt-3" onClick={applyHomeTypeFilter}>
                Apply
              </Button>
            </div>

          </Dropdown.Menu>
        </Dropdown>

        <Dropdown
          className="more-filter"
          show={showMoreFilterDropdown}
          onToggle={(open) => setShowMoreFilterDropdown(open)}
          align="end"
        >
          <Dropdown.Toggle id="more-filter-dropdown">
            <img src={MoreFilter} alt="" />More Filter
          </Dropdown.Toggle>

          <Dropdown.Menu as="div" className="more-filter-dropdown">
            <h5 className="dropdown-title">More Filters</h5>
            <div className="more-filter-options">
              <Form className="w-100">
                <div className="more-filter-options-wrap">

                  <Form.Label>Listing Type</Form.Label>
                  {listingTypes.map(t => (
                    <div key={t.key} className="listing-type-row">
                      <Form.Check
                        type="checkbox"
                        id={`lt-${t.key}`}
                        label={t.label}
                        className="custom-checkbox primary mb-0"
                        checked={!!listingTypeFilters[t.key]}
                        onChange={() => toggleListingType(t.key)}
                      />
                      {t.tooltip && (
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id={`tip-${t.key}`}>{t.tooltip}</Tooltip>}
                        >
                          <img src={TooltipIconOne} alt="" />
                        </OverlayTrigger>
                      )}
                    </div>
                  ))}





                  <div className="d-flex gap-3 w-100">
                    <div className="d-flex flex-column flex-grow-1">
                      <Form.Label>Lot size</Form.Label>
                      <Form.Select aria-label="min_size_sqft" name="size_sqft" onChange={(e) => setSizeSqft(e.target.value)}>
                        <option value="No Min">No Min</option>
                        <option value="100">100</option>
                        <option value="500">500</option>
                        <option value="1000">1000</option>
                        <option value="10000">10000</option>
                      </Form.Select>
                    </div>
                    <div className="d-flex flex-column flex-grow-1">
                      <Form.Label></Form.Label>
                      <Form.Select aria-label="max_size_sqft" name="max_size_sqft" onChange={(e) => setMaxSizeSqft(e.target.value)}>
                        <option value="No Max">No Max</option>
                        <option value="100">100</option>
                        <option value="500">500</option>
                        <option value="1000">1000</option>
                        <option value="10000">10000</option>
                      </Form.Select>
                    </div>
                  </div>
                  <div className="d-flex gap-3 w-100">
                    <div className="d-flex flex-column flex-grow-1">
                      <Form.Label>Year built</Form.Label>
                      <Form.Select aria-label="min_year_built" name="min_year_built" onChange={(e) => setMinYearBuilt(e.target.value)}>
                        <option value="No Min">No Min</option>
                        <option value="2000">2000</option>
                        <option value="2011">2011</option>
                      </Form.Select>
                    </div>
                    <div className="d-flex flex-column flex-grow-1">
                      <Form.Label></Form.Label>
                      <Form.Select aria-label="max_year_built" name="max_year_built" onChange={(e) => setMaxYearBuilt(e.target.value)}>
                        <option value="No Max">No Max</option>
                        <option value="2000">2000</option>
                        <option value="2011">2011</option>
                      </Form.Select>
                    </div>
                  </div>

                </div>
                <ButtonGroup className="w-100 d-flex gap-3">
                  <Button className="custom-bttn clear-all w-100" onClick={applyMoreFilters}>
                    Clear All
                  </Button>
                  <Button className="custom-bttn w-100" onClick={applyMoreFilters}>
                    Apply
                  </Button>
                </ButtonGroup>
              </Form>
            </div>
          </Dropdown.Menu>
        </Dropdown>
        <Button className="custom-bttn ms-3" onClick={handleSubmit}>
          <img className="me-2" src={SearchIcon} alt="" /> Search
        </Button>

      </div>
    </>

  )
};

export default FilterBar;
